<template>
  <v-card>
    <v-card-text
      class="text-xs-center headline secondary--text pb-0"
    >
      Inserindo nova forma de recebimento
    </v-card-text>
    <v-stepper v-model="step" class="elevation-0">
      <v-stepper-items>
        <v-stepper-content
          step="1"
          class="pa-0"
        >
          <v-container flex grid-list-lg>
            <v-form v-model="valid1" ref="firstForm">
              <v-layout
                justify-center
                row
                wrap
              >
                <v-flex
                  xs12
                  class="title primary--text text-xs-center"
                >
                  Selecione uma das formas abaixo
                </v-flex>
                <v-flex
                  xs12
                  md8
                >
                  <v-select
                    v-model="pagamento"
                    outline
                    placeholder="Clique para selecionar"
                    single-line
                    :items="formasPag"
                    item-text="descricao"
                    required
                    return-object
                    hide-details
                    :rules="[
                        v => !!v || ''
                    ]"
                  ></v-select>
                </v-flex>
                <v-flex
                  xs12
                  md8
                >
                  <v-select
                    v-model="destino_selecionado"
                    outline
                    label="Destino"
                    single-line
                    :items="destinos"
                    item-text="text"
                    item-value="value"
                    required
                    hide-details
                    :rules="[
                        v => !!v || ''
                    ]"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
        <v-stepper-content
          step="2"
          class="pa-0"
        >
          <v-container
            flex
            grid-list-lg
          >
            <v-form
              v-model="valid2"
              ref="secondForm"
            >
              <v-layout
                justify-center
                row
                wrap
                v-if="!loading"
              >
                <v-flex
                  xs12
                  class="
                    title
                    primary--text
                    text-xs-center
                  "
                >
                  Insira os dados para os seguintes campos
                </v-flex>
                <v-flex
                  xs11
                  class="secondary--text text-xs-center"
                  v-if="pagamento_secundario"
                >
                  ATENÇÃO! Esta forma de pagamento é secundária, usada para recebimento pix e carteira digital pelo posto.
                </v-flex>
                <template v-for="(field, index) in fields">
                  <v-flex :key="index" xs12 md10 v-if="field === 'chave_pix'">
                  <v-select
                    label="Tipo de chave"
                    :items="[
                      'CNPJ',
                      'Número de Telefone',
                      'Chave Aleatória'
                    ]"
                    v-model="tipo_chave"
                  />
                  <v-text-field
                    :label="field"
                    v-model="pagamento_model.formulario[field]"
                    hide-details
                    required
                    :mask="
                      tipo_chave === 'CNPJ' ? '##.###.###/####-##' : (tipo_chave === 'Número de Telefone' ? '(##) # ####-####' : '')
                    "
                    :rules="[
                      v => !!v || ''
                    ]"
                  />
                  </v-flex>
                  <v-flex
                    :key="index"
                    xs12
                    md10
                    v-else
                  >
                    <v-text-field
                      :label="field"
                      v-model="pagamento_model.formulario[field]"
                      hide-details
                      required
                      :rules="[
                        v => !!v || ''
                      ]"
                    />
                  </v-flex>
                </template>
              </v-layout>
              <v-layout
                justify-center
                class="ma-4"
                v-else
              >
                <v-progress-circular
                  size="100"
                  color="info"
                  indeterminate
                />
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-btn
        block
        flat
        @click="cancelar()"
      >
        CANCELAR
      </v-btn>
      <v-btn
        block
        flat
        color="green"
        :disabled="disabledBtn"
        @click="continuar()"
        :loading="loading"
      >
        <template v-if="step === 1">CONTINUAR</template>
        <template v-else-if="step === 2">CONFIRMAR</template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      tipo_chave: 'CNPJ',
      step: 1,
      valid1: false,
      valid2: false,
      fields: [],
      pagamento: null,
      pagamento_secundario: null,
      destino_selecionado: 1,
      destinos: [
        {
          text: 'Para Clientes',
          value: 1
        },
        {
          text: 'Para Postos',
          value: 2
        },
        {
          text: 'Para Empresas',
          value: 3
        },
        {
          text: 'Para Todos',
          value: 4
        },
        {
          text: 'Para Verificar o Cartão',
          value: 5
        }
      ],
      pagamento_model: {
        formulario: {},
        aceitar_credito: true,
        aceitar_debito: true,
        is_admin: true,
        posto: null,
        empresa: null
      },
      formasPag: []
    }
  },
  computed: {
    disabledBtn () {
      switch (this.step) {
        case 1:
          return !this.pagamento
      }
      return false
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  watch: {
    pagamento (val) {
      if (val) {
        this.fields = val.nome_campos.split(',')
        this.pagamento_secundario = val.pagamento_secundario
      }
    },
    headers (val) {
      if (val) {
        this.carregarFormasPagamento()
      }
    }
  },
  beforeMount () {
    if (this.headers) {
      this.carregarFormasPagamento()
    }
  },
  methods: {
    carregarFormasPagamento () {
      this.$store.dispatch('carregarFormasPagamento').then(json => {
        this.formasPag = json
      })
    },
    continuar () {
      switch (this.step) {
        case 1:
          if (this.$refs.firstForm.validate()) {
            this.step = 2
          }
          break
        case 2:
          if (this.$refs.secondForm.validate()) {
            this.vincularPagamento()
          }
          break
      }
    },
    vincularPagamento () {
      this.loading = true
      if (this.tipo_chave === 'Número de Telefone') this.pagamento_model.formulario.chave_pix = `+55${this.pagamento_model.formulario.chave_pix}`
      this.pagamento_model.destino = this.destino_selecionado
      this.$store.dispatch(
        'vincularPagamentoExtra',
        {
          body: this.pagamento_model,
          pagamento: this.pagamento.id_forma_pagamento
        }
      ).then(() => {
          this.loading = false
            this.$emit(
              'showSnackbar',
              'Forma de pagamento foi vinculada com sucesso!',
              'primary'
            )
          }).catch(() => {
            this.$emit(
              'showSnackbar',
              'Infelizmente a forma de pagamento não pôde ser inserida!',
              'error'
            )
          })
          this.cancelar()
    },
    cancelar () {
      this.$refs.firstForm.reset()
      this.$refs.secondForm.reset()
      this.step = 1
      this.$emit('fechar')
    }
  }
}
</script>
